module.exports = __webpack_public_path__ + "static/media/teygja_utanverdlaeri.420da0c7.png";